// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import * as css from './TablaRegiones.css'
export class RowRegiones extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render(){
        return (
            <tr key={1}>
                <td>{this.props.correlativo}</td>
                <td>{this.props.region.numeroRegion}</td>
                <td className={css.tdNombre}>{this.props.region.nombreRegion}</td>
                <td className={css.tdRealizadas}>{this.props.region.precio}</td>
                <td className={css.tdRealizadas}>{this.props.region.totalMes}</td>
                <td className={css.tdTotal}>{this.props.region.totalPrecioFormat}</td>
                <td className={css.tdOpcion}>
                    <a className="btn btn-success btn-xs"
                       href={`/auditorias/descargar/${this.props.mes}/${this.props.region.cutRegion}`}>
                        Exportar
                    </a>
                </td>
            </tr>
        )
    }
}
RowRegiones.propTypes = {
    region: PropTypes.object,
    correlativo: PropTypes.number,
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/resumen-mensual/RowRegiones.jsx